import { createContext, ReactNode, useContext } from "react";

import { useFilterVehicleTransaction } from "./filter-vehicle-transaction.hook";

const FilterVehicleTransactionContext = createContext(
  {} as ReturnType<typeof useFilterVehicleTransaction>
);
export function useFilterVehicleTransactionContext() {
  return useContext(FilterVehicleTransactionContext);
}

interface FilterVehicleTransactionProviderProps {
  children: ReactNode;
}
export function FilterVehicleTransactionProvider({
  children,
}: FilterVehicleTransactionProviderProps) {
  return (
    <FilterVehicleTransactionContext.Provider value={useFilterVehicleTransaction()}>
      {children}
    </FilterVehicleTransactionContext.Provider>
  );
}